import React from 'react'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  root: {
    paddingTop: '37px'
  }
}))

export const NmFormSubmitGroup = (props) => {
  const classes = useStyles()
  return (
    <div className={classes.root}>
      {props.children}
    </div>
  )
}
